// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"Loader_loader_wrapper__a9aEg","loader":"Loader_loader__JznZj","element":"Loader_element__SmPel","loading-keys-app-loading":"Loader_loading-keys-app-loading__nH53a"};